<template>
    <div class="content-grid content-grid--subpage">
        <Breadcrumbs :title="t('routes.admin.children.memberships.name')" />
        <div class="content-grid__header">
            <h1 class="back-link-title">{{ t(`routes.admin.children.memberships.name`) }}</h1>
        </div>
        <Card>
            <MembershipsForm />
        </Card>
    </div>
</template>

<script lang="ts" setup>
import Card from '@/components/layout/Card.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import MembershipsForm from '@/components/memberships/MembershipsForm.vue';

import { useI18n } from "vue3-i18n";

const { t } = useI18n()
</script>
